<template>
  <div :class="cardClass">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "CardHeader",
  status: "prototype",
  release: "1.0.0",
  props: {
    color: {
      type: String,
      default: null,
    }
  },
  computed: {
    cardClass() {
      const classes = ['card-header'];
      if (!!this.color) {
        classes.push(`card-header--${this.color}`);
      }
      return classes;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.card-header {
  @include reset();
  padding: 30px 30px 20px 30px;
  margin: -20px -30px 0 -30px;
  border-radius: 15px 15px 0 0;
  background-color: $color-purple-darker;
    &--purple-lighter {
      background-color: $color-purple-lighter;
    }
    &--purple-light {
      background-color: $color-purple-light;
    }
    &--purple {
      background-color: $color-purple;
    }
    &--purple-dark {
      background-color: $color-purple-dark;
    }
    &--purple-darker {
      background-color: $color-purple-darker;
    }
    &--gray-light {
      background-color: $color-gray-light;
    }
    &--gray {
      background-color: $color-gray;
    }
    &--gray-dark {
      background-color: $color-gray-dark;
    }
    &--yellow-lighter {
      background-color: $color-yellow-lighter;
    }
    &--yellow-light {
      background-color: $color-yellow-light;
    }
    &--yellow {
      background-color: $color-yellow;
    }
    &--green {
      background-color: $color-green;
    }
    &--pink-lighter {
      background-color: $color-pink-lighter;
    }
    &--pink-light {
      background-color: $color-pink-light;
    }
    &--pink {
      background-color: $color-pink;
    }
    &--white {
      background-color: $color-white;
    }
    &--rich-black {
      background-color: $color-rich-black;
    }
}
</style>
